import React from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import CloseImage from '../../assets/ic_close.png';
import { useStyles, BootstrapInput } from '../../library/selectOption';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField } from '@material-ui/core';

export default function FilterPasien(props) {
    const classes = useStyles();
    const listJenkel = [
        { value: 'Male' },
        { value: 'Female' },
    ]
    const listUmur = [
        "10", "20", "30"
    ]
    const [jenisKel, setJenisKel] = React.useState("");
    const [umurPasien, setUmurPasien] = React.useState("")
    return (
        <div className="App app-popup-show">
            <div className="popup-content background-white" style={{ height: '100%', position: 'absolute', right: 0, width: '33%' }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Filter Data</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>
                <div className="grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50, height: 400 }}>
                    <div className="column-1">
                        <div className="">

                            <div style={{ marginTop: 20 }}>
                                <Autocomplete
                                    options={listJenkel}
                                    getOptionLabel={(option) => option.value}
                                    variant="outlined"
                                    debug
                                    onChange={(event, newInputValue) => setJenisKel(newInputValue.value)}
                                    renderInput={(params) =>
                                        <TextField
                                            variant="outlined"
                                            {...params}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 15 } }}
                                            InputLabelProps={{ style: { fontSize: 15, color: '#7e8085' } }}
                                            label="Jenis Kelamin"
                                        />
                                    }
                                // value={jenisKelamin}
                                />
                            </div>
                            <div style={{ marginTop: 40 }}>
                                <Autocomplete
                                    options={listUmur}
                                    getOptionLabel={(option) => option}
                                    variant="outlined"
                                    debug
                                    onChange={(event, newInputValue) => setUmurPasien(newInputValue)}
                                    renderInput={(params) =>
                                        <TextField
                                            variant="outlined"
                                            {...params}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 15 } }}
                                            InputLabelProps={{ style: { fontSize: 15, color: '#7e8085' } }}
                                            label="Umur Pasien"
                                        />
                                    }
                                // value={jenisKelamin}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}